// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"Banner_bannerWrapper__6wNJz","card":"Banner_card__T1bY8","loaded":"Banner_loaded__W5iEU"};